import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "time-entries-tab space-y-4 pt-4"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1,
  class: "text-center py-8"
};
const _hoisted_4 = {
  key: 2,
  class: "space-y-4"
};
const _hoisted_5 = {
  key: 0,
  class: "text-center py-12 border rounded-lg"
};
const _hoisted_6 = {
  key: 1,
  class: "time-entries-accordion space-y-3"
};
const _hoisted_7 = {
  key: 0,
  class: "flex justify-start gap-3 overflow-x-auto"
};
const _hoisted_8 = {
  class: "border border-gray-200 rounded-lg overflow-hidden"
};
const _hoisted_9 = {
  class: "flex items-center gap-2"
};
const _hoisted_10 = {
  class: "text-sm text-gray-500"
};
const _hoisted_11 = {
  class: "flex items-center gap-2"
};
const _hoisted_12 = {
  key: 0,
  class: "text-sm px-2 py-0.5 rounded-md border text-green-600 bg-green-50 border-green-600"
};
const _hoisted_13 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_14 = {
  class: "w-5 h-5 flex items-center justify-center flex-shrink-0"
};
const _hoisted_15 = {
  class: "text-gray-900 text-sm"
};
const _hoisted_16 = {
  class: "text-gray-700 text-sm"
};
const _hoisted_17 = {
  class: "text-gray-900 text-sm font-medium text-right block"
};
const _hoisted_18 = {
  key: 0,
  class: "text-gray-900 text-sm font-medium text-right block"
};
const _hoisted_19 = {
  key: 1,
  class: "text-gray-400 text-sm text-right block"
};
const _hoisted_20 = {
  class: "text-center"
};
const _hoisted_21 = {
  key: 1,
  class: "text-center py-8 border-t border-gray-200"
};
const _hoisted_22 = {
  class: "border border-gray-200 rounded-lg overflow-hidden"
};
const _hoisted_23 = {
  class: "flex items-center gap-2"
};
const _hoisted_24 = {
  class: "text-sm text-gray-500"
};
const _hoisted_25 = {
  class: "flex items-center gap-2"
};
const _hoisted_26 = {
  class: "text-gray-900 text-sm"
};
const _hoisted_27 = {
  class: "text-gray-700 text-sm"
};
const _hoisted_28 = {
  class: "text-gray-900 text-sm font-medium text-right block"
};
const _hoisted_29 = {
  key: 0,
  class: "text-gray-900 text-sm font-medium text-right block"
};
const _hoisted_30 = {
  key: 1,
  class: "text-gray-400 text-sm text-right block"
};
const _hoisted_31 = {
  class: "text-center"
};
const _hoisted_32 = {
  key: 1,
  class: "text-center py-8 border-t border-gray-200"
};
import { ref, computed, watch, onMounted, shallowReactive } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useChargesStore } from '@/services/UserService/useChargesStore';
import { formatCurrency, pluralizeWithCount, getShortDateString, pluralizeEntry, pluralizeEntryWithCount } from '@/services/utils';
import isEntryBilled from '@/utils/entryUtils';
import { EMPTY_VALUE, TIME_ENTRIES_SKELETON, BulkUpdateType } from '@/modules/fixedfees/constants';
import { TrackingCategory, TrackingAction } from '@/constants/trackingConstants';
import SkeletonRenderer from '@/components/SkeletonRenderer.vue';
import TimeEntryModal from '@/modules/time/timeEntryModal.vue';
import LlUserAvatar from '@/components/LlUserAvatar.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import LlTooltip from '@/components/LlTooltip.vue';
import LlAssignToFixedFeeModal from '@/components/LlAssignToFixedFeeModal.vue';
import { useEntryProcessState } from '@/composables/useEntryProcessState';
import { useFixedFeeBulkOperations } from '@/composables/useFixedFeeBulkOperations';
import ChargeService from '@/services/ChargeService';
import ChangeMatterDialog from '@/components/ChangeMatterDialog.vue';
import EventTracker from '@/services/eventTracker';
export default {
  __name: 'FixedFeeTimeEntriesTab',
  props: {
    chargeId: {
      type: String,
      required: false,
      default: null
    },
    matterId: {
      type: String,
      required: false,
      default: null
    },
    // Angular services for modal
    state: {
      type: Object,
      required: false
    },
    stateParams: {
      type: Object,
      required: false
    },
    rootScope: {
      type: Object,
      required: false
    },
    alerts: {
      type: Object,
      required: false
    },
    snippetService: {
      type: Object,
      required: false
    },
    entryEditService: {
      type: Object,
      required: false
    },
    tracking: {
      type: Object,
      required: false
    },
    clientMatterManager: {
      type: Object,
      required: false
    }
  },
  emits: ['entries-changed'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;

    // Composables
    const {
      handleError,
      handleSuccess,
      handleWarning
    } = useSnackbarHandler();

    // Store
    const meStore = useMeStore();
    const {
      me,
      permissions,
      features
    } = storeToRefs(meStore);
    const chargesStore = useChargesStore();

    // Emits
    const emit = __emit;

    // State
    const loading = ref(true);
    const error = ref(null);
    const wipEntries = ref([]);
    const nonWipEntries = ref([]);
    const wipSummary = ref({
      count: 0,
      hours: 0,
      total: 0
    });
    const nonWipSummary = ref({
      count: 0,
      hours: 0,
      total: 0
    });
    const showTimeEntryModal = ref(false);
    const selectedEntryId = ref(null);
    const selectedWipEntries = ref([]);

    // ─── Bulk Operations (shared with EntryList) ───────────────
    const {
      bulkOperationLoading,
      billableConfirmRef,
      nonBillableConfirmRef,
      billableConfirmMessage,
      nonBillableConfirmMessage,
      confirmMakeBillable,
      confirmMakeNonBillable,
      // Change Matter dialog state + handlers
      showChangeMatterDialog,
      changeMatterForm,
      openChangeMatterDialog,
      closeChangeMatterDialog,
      handleChangeMatterMatterChange,
      confirmChangeMatter,
      // Entry process state pass-through
      setEntriesProcessing,
      clearEntryProcessState,
      handleBulkOperationResult,
      setAllFailed,
      getEntryProcessState,
      getRowClass
    } = useFixedFeeBulkOperations({
      getEntryIds: () => selectedWipEntries.value,
      clearSelection: () => {
        selectedWipEntries.value = [];
      },
      onAfterOperation: async () => {
        await loadEntries(true);
        emit('entries-changed');
      },
      messageContext: 'this',
      onTrackConvert: (billingType, convertedCount) => {
        if (props.tracking && convertedCount > 0) {
          const trackingType = billingType === 'Billable' ? BulkUpdateType.MAKE_BILLABLE : BulkUpdateType.MAKE_NON_BILLABLE;
          EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEE_TIME_ENTRIES, TrackingAction.BULK_OPERATION, {
            entryCount: convertedCount,
            type: trackingType
          });
        }
      },
      onTrackChangeMatter: successCount => {
        if (props.tracking && successCount > 0) {
          EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEE_TIME_ENTRIES, TrackingAction.BULK_OPERATION, {
            entryCount: successCount,
            type: BulkUpdateType.CHANGE_MATTER
          });
        }
      }
    });

    // Row props computed for v-data-table
    const getRowProps = ({
      item
    }) => ({
      class: getRowClass(item.id)
    });

    // Accordion expansion state
    const wipExpanded = ref(true); // WIP expanded by default
    const nonWipExpanded = ref(false); // Billed/Invoiced collapsed by default

    // Toggle functions for accordion panels
    const toggleWipPanel = () => {
      wipExpanded.value = !wipExpanded.value;
    };
    const toggleNonWipPanel = () => {
      nonWipExpanded.value = !nonWipExpanded.value;
    };

    // Assign to fee modal state
    const showAssignToFeeModal = ref(false);
    const availableCharges = ref([]);
    const loadingCharges = ref(false);

    // Modal state params
    const modalStateParams = computed(() => ({
      entryId: selectedEntryId.value
    }));
    const wipEntryById = computed(() => new Map(wipEntries.value.map(e => [e.id, e])));

    // Check if any selected WIP entries are billed (cannot be modified)
    const hasSelectedBilledEntries = computed(() => selectedWipEntries.value.some(id => {
      const entry = wipEntryById.value.get(id);
      return entry ? isEntryBilled(entry) : false;
    }));

    // Bulk action button states
    const isBulkActionDisabled = computed(() => selectedWipEntries.value.length === 0 || hasSelectedBilledEntries.value || bulkOperationLoading.value);

    // Note: We don't include loadingCharges here - the modal handles loading state internally.
    // This prevents the button from being stuck disabled if the charges API is slow.
    const isReassignDisabled = computed(() => isBulkActionDisabled.value);

    // Computed
    const canViewRates = computed(() => permissions.value?.time?.viewRates || false);
    const headers = computed(() => [{
      title: 'Date',
      value: 'date',
      sortable: true,
      width: '120px'
    }, {
      title: 'Time Keeper',
      value: 'timeKeeper',
      sortable: true,
      width: '150px'
    }, {
      title: 'Description',
      value: 'description',
      sortable: false
    }, {
      title: 'Hrs',
      value: 'hours',
      sortable: true,
      align: 'end',
      width: '80px'
    }, {
      title: 'Value',
      value: 'value',
      sortable: true,
      align: 'end',
      width: '100px'
    }, {
      title: '',
      value: 'actions',
      sortable: false,
      align: 'center',
      width: '50px'
    }]);

    // Headers without select for non-WIP (billed) entries
    const headersWithoutSelect = computed(() => headers.value);
    const viewEntry = entry => {
      if (!entry?.id) {
        return;
      }
      selectedEntryId.value = entry.id;
      showTimeEntryModal.value = true;
    };
    const handleEntryUpdate = data => {
      // Close modal and reload entries with force refresh
      showTimeEntryModal.value = false;
      selectedEntryId.value = null;
      loadEntries(true); // Force refresh to get updated data from API
    };
    const handleModalClose = () => {
      showTimeEntryModal.value = false;
      selectedEntryId.value = null;
      // Reload entries when modal closes
      loadEntries();
    };
    const loadEntries = async (forceRefresh = false) => {
      if (!props.chargeId) {
        wipEntries.value = [];
        nonWipEntries.value = [];
        wipSummary.value = {
          count: 0,
          hours: 0,
          total: 0
        };
        nonWipSummary.value = {
          count: 0,
          hours: 0,
          total: 0
        };
        loading.value = false;
        return;
      }
      loading.value = true;
      error.value = null;
      try {
        const data = await chargesStore.loadChargeTimeEntries(props.chargeId, forceRefresh);

        // Transform function for entries
        const transformEntry = entry => {
          // Story #41530: Extract localDateTime date when feature flag enabled
          const dateValue = features.value?.dateHandling && entry.localDateTime && entry.localDateTime.date ? entry.localDateTime.date : entry.date;
          return {
            date: dateValue,
            timeKeeper: entry.account?.name || EMPTY_VALUE,
            initials: entry.account?.initials,
            description: entry.description || EMPTY_VALUE,
            hours: entry.hours || 0,
            value: entry.cost?.amount || 0,
            id: entry.id,
            billingType: entry.billingType,
            // Preserve for bulk operations
            accountId: entry.account?.id,
            // Preserve for bulk operations
            billed: entry.billed,
            // Track if entry is billed
            billedState: entry.billedState,
            // Track billing state (WIP, Interim, etc.)
            invoice: entry.invoice // Track if entry is in an invoice
          };
        };

        // Handle new API response structure with wip and nonWip sections
        if (data && (data.wip || data.nonWip)) {
          // New response format
          wipEntries.value = (data.wip?.entries || []).map(transformEntry);
          nonWipEntries.value = (data.nonWip?.entries || []).map(transformEntry);

          // Use summary from API response
          wipSummary.value = data.wip?.summary || {
            count: 0,
            hours: 0,
            total: 0
          };
          nonWipSummary.value = data.nonWip?.summary || {
            count: 0,
            hours: 0,
            total: 0
          };
        } else {
          // Fallback for old response format (flat array)
          const allEntries = (data || []).map(transformEntry);
          wipEntries.value = allEntries.filter(e => !e.billed);
          nonWipEntries.value = allEntries.filter(e => e.billed);

          // Calculate summaries manually for old format
          wipSummary.value = {
            count: wipEntries.value.length,
            hours: wipEntries.value.reduce((sum, e) => sum + (e.hours || 0), 0),
            total: wipEntries.value.reduce((sum, e) => sum + (e.value || 0), 0)
          };
          nonWipSummary.value = {
            count: nonWipEntries.value.length,
            hours: nonWipEntries.value.reduce((sum, e) => sum + (e.hours || 0), 0),
            total: nonWipEntries.value.reduce((sum, e) => sum + (e.value || 0), 0)
          };
        }
      } catch (err) {
        wipEntries.value = [];
        nonWipEntries.value = [];
        wipSummary.value = {
          count: 0,
          hours: 0,
          total: 0
        };
        nonWipSummary.value = {
          count: 0,
          hours: 0,
          total: 0
        };
        error.value = err;
      } finally {
        loading.value = false;
      }
    };
    const clearSelection = () => {
      selectedWipEntries.value = [];
    };

    // Reassign to fee logic
    const loadAvailableCharges = async () => {
      if (!props.matterId) return;
      loadingCharges.value = true;
      try {
        // acceptsTime, not billed=false: this feeds bulkAssignEntriesToCharge,
        // which now accepts a Billed + Time Unlocked fee too (FFLOCK T-08).
        // acceptsTime subsumes billed, so it's left undefined here rather than
        // passing a stale `false` that reads as if it still mattered.
        const charges = await ChargeService.listCharges(props.matterId, undefined, true);

        // Filter out the current charge
        availableCharges.value = charges.filter(c => c.id !== props.chargeId);
      } catch (err) {
        handleError('Failed to load available fees');
        console.error('Error loading available charges:', err);
      } finally {
        loadingCharges.value = false;
      }
    };

    // Modal functions for Assign to Fee
    const openAssignToFeeModal = () => {
      showAssignToFeeModal.value = true;
    };
    const closeAssignToFeeModal = () => {
      showAssignToFeeModal.value = false;
    };
    const handleAssignToFee = async selectedFixedFee => {
      const chargeId = selectedFixedFee?.id || selectedFixedFee;
      if (!chargeId || selectedWipEntries.value.length === 0) {
        return;
      }
      showAssignToFeeModal.value = false;
      await handleReassignToFee(chargeId);
    };
    const handleReassignToFee = async targetChargeId => {
      // selectedWipEntries is already an array of IDs (strings) because item-value="id" is set on v-data-table
      const entryIds = selectedWipEntries.value;
      const count = entryIds.length;
      bulkOperationLoading.value = true;

      // Clear previous process states and set all selected entries to processing
      clearEntryProcessState();
      setEntriesProcessing(entryIds);
      try {
        const targetCharge = availableCharges.value.find(c => c.id === targetChargeId);
        const targetName = targetCharge?.description || targetCharge?.label || 'selected fee';

        // Call bulk assign API with new signature: (chargeId, entryIds, force)
        const result = await ChargeService.bulkAssignEntriesToCharge(targetChargeId, entryIds, true);

        // Handle result using consolidated helper
        const hasErrors = handleBulkOperationResult(entryIds, result.errors, 'itemId', 'reason');
        const entryText = pluralizeEntryWithCount(count);
        if (hasErrors) {
          handleWarning(`Reassigned ${result.successCount} of ${entryText} to ${targetName}. See warning icons for failed entries.`);
        } else {
          handleSuccess(`Successfully reassigned ${entryText} to ${targetName}`);
        }

        // Track bulk assign to fee event
        if (props.tracking && result.successCount > 0) {
          EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEE_TIME_ENTRIES, TrackingAction.BULK_OPERATION, {
            entryCount: result.successCount,
            type: BulkUpdateType.CHANGE_FEE
          });
        }

        // Clear selection
        clearSelection();

        // Reload entries
        await loadEntries(true);
        // Notify parent to refresh fixed fee details (client/matter name, totals, etc.)
        emit('entries-changed');
      } catch (err) {
        // Mark all entries as failed on general error
        setAllFailed(entryIds);
        handleError('Failed to reassign entries');
        console.error('Error reassigning entries:', err);
      } finally {
        bulkOperationLoading.value = false;
      }
    };

    // Watchers
    watch(() => props.chargeId, () => {
      // Clear stale inline error/processing indicators when switching fees
      clearEntryProcessState();
      loadEntries();
    }, {
      immediate: false
    });
    watch(() => props.matterId, () => {
      loadAvailableCharges();
    }, {
      immediate: false
    });

    // Lifecycle
    onMounted(() => {
      loadEntries();
      loadAvailableCharges();
    });

    // Expose methods for parent component
    __expose({
      loadEntries
    });
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_list_item_title = _resolveComponent("v-list-item-title");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_list = _resolveComponent("v-list");
      const _component_v_menu = _resolveComponent("v-menu");
      const _component_v_data_table = _resolveComponent("v-data-table");
      const _component_v_expand_transition = _resolveComponent("v-expand-transition");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(SkeletonRenderer, {
        spec: _unref(TIME_ENTRIES_SKELETON),
        "container-class": "pt-4 space-y-4"
      }, null, 8, ["spec"])])) : error.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_v_icon, {
        icon: "mdi-alert-circle",
        size: "64",
        color: "error",
        class: "mb-4"
      }), _cache[6] || (_cache[6] = _createElementVNode("p", {
        class: "text-gray-700"
      }, "Failed to load time entries", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [wipEntries.value.length === 0 && nonWipEntries.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_v_icon, {
        icon: "mdi-clock-outline",
        size: "48",
        color: "grey-lighten-2",
        class: "mb-3"
      }), _cache[7] || (_cache[7] = _createElementVNode("p", {
        class: "text-gray-600"
      }, "No time entries for this fixed fee", -1))])) : _createCommentVNode("", true), wipEntries.value.length > 0 || nonWipEntries.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [wipEntries.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(LlSecondaryButton, {
        variant: "outlined",
        disabled: isBulkActionDisabled.value,
        onClick: _unref(openChangeMatterDialog),
        "data-cy": "move-to-matter-button",
        "prepend-icon": "mdi-swap-horizontal"
      }, {
        default: _withCtx(() => [_createTextVNode(" Change " + _toDisplayString(_unref(me)?.terms?.Matter || 'Matter'), 1)]),
        _: 1
      }, 8, ["disabled", "onClick"]), _createVNode(LlSecondaryButton, {
        variant: "outlined",
        color: "primary",
        disabled: isBulkActionDisabled.value,
        onClick: _unref(confirmMakeBillable)
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" Make Billable ", -1)]))]),
        _: 1
      }, 8, ["disabled", "onClick"]), _createVNode(LlSecondaryButton, {
        variant: "outlined",
        color: "orange-darken-1",
        disabled: isBulkActionDisabled.value,
        onClick: _unref(confirmMakeNonBillable)
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" Make Non-Billable ", -1)]))]),
        _: 1
      }, 8, ["disabled", "onClick"]), _createVNode(LlSecondaryButton, {
        variant: "flat",
        color: "primary",
        disabled: isReassignDisabled.value,
        onClick: openAssignToFeeModal,
        "data-cy": "assign-to-fee-button"
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" Assign to Fee ", -1)]))]),
        _: 1
      }, 8, ["disabled"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
        type: "button",
        class: "w-full flex items-center justify-between px-4 py-3 bg-white hover:bg-gray-50 transition-colors",
        onClick: toggleWipPanel
      }, [_createElementVNode("div", _hoisted_9, [_cache[11] || (_cache[11] = _createElementVNode("span", {
        class: "text-base font-semibold text-gray-900"
      }, "WIP Time Entries", -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(wipSummary.value.count) + " " + _toDisplayString(wipSummary.value.count === 1 ? 'entry' : 'entries') + " | " + _toDisplayString(_ctx.hoursDecimal(wipSummary.value.hours)) + " hours | " + _toDisplayString(_unref(formatCurrency)(wipSummary.value.total)), 1)]), _createElementVNode("div", _hoisted_11, [selectedWipEntries.value.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(selectedWipEntries.value.length) + " " + _toDisplayString(selectedWipEntries.value.length === 1 ? 'entry' : 'entries') + " selected ", 1)) : _createCommentVNode("", true), _createVNode(_component_v_icon, {
        icon: wipExpanded.value ? 'mdi-chevron-down' : 'mdi-chevron-right',
        size: "24",
        color: "grey"
      }, null, 8, ["icon"])])]), _createVNode(_component_v_expand_transition, null, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", null, [wipEntries.value.length > 0 ? (_openBlock(), _createBlock(_component_v_data_table, {
          key: 0,
          modelValue: selectedWipEntries.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedWipEntries.value = $event),
          items: wipEntries.value,
          headers: headers.value,
          density: "comfortable",
          "items-per-page": -1,
          "hide-default-footer": "",
          "show-select": "",
          "select-strategy": _unref(bulkOperationLoading) ? 'none' : 'page',
          "item-value": "id",
          class: _normalizeClass(["fixed-fee-entries-table [&_.v-data-table__tr]:cursor-pointer [&_.v-data-table__tr:hover]:bg-green-50/10", {
            'pointer-events-none opacity-60': _unref(bulkOperationLoading)
          }]),
          "row-props": getRowProps,
          "onClick:row": _cache[1] || (_cache[1] = (event, {
            item
          }) => viewEntry(item))
        }, {
          "item.date": _withCtx(({
            item
          }) => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_unref(getEntryProcessState)(item.id).processing ? (_openBlock(), _createBlock(_component_v_progress_circular, {
            key: 0,
            indeterminate: "",
            size: "16",
            width: "2",
            color: "primary"
          })) : _unref(getEntryProcessState)(item.id).error ? (_openBlock(), _createBlock(LlTooltip, {
            key: 1,
            text: _unref(getEntryProcessState)(item.id).error,
            location: "top"
          }, {
            activator: _withCtx(() => [_createVNode(_component_v_icon, {
              icon: "mdi-alert",
              size: "18",
              color: "warning",
              class: "cursor-help"
            })]),
            _: 1
          }, 8, ["text"])) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(features).dateHandling ? _unref(getShortDateString)(item.date) : _ctx.formatDate(item.date)), 1)])]),
          "item.timeKeeper": _withCtx(({
            item
          }) => [_createVNode(LlUserAvatar, {
            initials: item.initials,
            name: item.timeKeeper
          }, null, 8, ["initials", "name"])]),
          "item.description": _withCtx(({
            item
          }) => [_createElementVNode("span", _hoisted_16, _toDisplayString(item.description), 1)]),
          "item.hours": _withCtx(({
            item
          }) => [_createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.hoursDecimal(item.hours)), 1)]),
          "item.value": _withCtx(({
            item
          }) => [canViewRates.value ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(formatCurrency)(item.value)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_19, "—"))]),
          "item.actions": _withCtx(({
            item
          }) => [_createElementVNode("div", _hoisted_20, [_createVNode(_component_v_menu, {
            location: "bottom end"
          }, {
            activator: _withCtx(({
              props: menuProps
            }) => [_createVNode(LlSecondaryButton, _mergeProps({
              icon: "mdi-dots-horizontal",
              variant: "text",
              size: "small"
            }, menuProps, {
              density: "comfortable",
              "aria-label": "Time entry actions"
            }), null, 16)]),
            default: _withCtx(() => [_createVNode(_component_v_list, {
              density: "compact"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_list_item, {
                onClick: $event => viewEntry(item)
              }, {
                default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("View Entry", -1)]))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["onClick"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)])]),
          _: 1
        }, 8, ["modelValue", "items", "headers", "select-strategy", "class"])) : (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[13] || (_cache[13] = [_createElementVNode("p", {
          class: "text-gray-500 text-sm"
        }, "No WIP time entries", -1)]))]))], 512), [[_vShow, wipExpanded.value]])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_22, [_createElementVNode("button", {
        type: "button",
        class: "w-full flex items-center justify-between px-4 py-3 bg-white hover:bg-gray-50 transition-colors",
        onClick: toggleNonWipPanel
      }, [_createElementVNode("div", _hoisted_23, [_cache[14] || (_cache[14] = _createElementVNode("span", {
        class: "text-base font-semibold text-gray-900"
      }, "Billed/Invoiced Time Entries", -1)), _createElementVNode("span", _hoisted_24, _toDisplayString(nonWipSummary.value.count) + " " + _toDisplayString(nonWipSummary.value.count === 1 ? 'entry' : 'entries') + " | " + _toDisplayString(_ctx.hoursDecimal(nonWipSummary.value.hours)) + " hours | " + _toDisplayString(_unref(formatCurrency)(nonWipSummary.value.total)), 1)]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_v_icon, {
        icon: nonWipExpanded.value ? 'mdi-chevron-down' : 'mdi-chevron-right',
        size: "24",
        color: "grey"
      }, null, 8, ["icon"])])]), _createVNode(_component_v_expand_transition, null, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", null, [nonWipEntries.value.length > 0 ? (_openBlock(), _createBlock(_component_v_data_table, {
          key: 0,
          items: nonWipEntries.value,
          headers: headersWithoutSelect.value,
          density: "comfortable",
          "items-per-page": -1,
          "hide-default-footer": "",
          "item-value": "id",
          class: "fixed-fee-entries-table [&_.v-data-table__tr]:cursor-pointer [&_.v-data-table__tr:hover]:bg-green-50/10",
          "onClick:row": _cache[2] || (_cache[2] = (event, {
            item
          }) => viewEntry(item))
        }, {
          "item.date": _withCtx(({
            item
          }) => [_createElementVNode("span", _hoisted_26, _toDisplayString(_unref(features).dateHandling ? _unref(getShortDateString)(item.date) : _ctx.formatDate(item.date)), 1)]),
          "item.timeKeeper": _withCtx(({
            item
          }) => [_createVNode(LlUserAvatar, {
            initials: item.initials,
            name: item.timeKeeper
          }, null, 8, ["initials", "name"])]),
          "item.description": _withCtx(({
            item
          }) => [_createElementVNode("span", _hoisted_27, _toDisplayString(item.description), 1)]),
          "item.hours": _withCtx(({
            item
          }) => [_createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.hoursDecimal(item.hours)), 1)]),
          "item.value": _withCtx(({
            item
          }) => [canViewRates.value ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(formatCurrency)(item.value)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_30, "—"))]),
          "item.actions": _withCtx(({
            item
          }) => [_createElementVNode("div", _hoisted_31, [_createVNode(_component_v_menu, {
            location: "bottom end"
          }, {
            activator: _withCtx(({
              props: menuProps
            }) => [_createVNode(LlSecondaryButton, _mergeProps({
              icon: "mdi-dots-horizontal",
              variant: "text",
              size: "small"
            }, menuProps, {
              density: "comfortable",
              "aria-label": "Time entry actions"
            }), null, 16)]),
            default: _withCtx(() => [_createVNode(_component_v_list, {
              density: "compact"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_list_item, {
                onClick: $event => viewEntry(item)
              }, {
                default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("View Entry", -1)]))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["onClick"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)])]),
          _: 1
        }, 8, ["items", "headers"])) : (_openBlock(), _createElementBlock("div", _hoisted_32, [...(_cache[16] || (_cache[16] = [_createElementVNode("p", {
          class: "text-gray-500 text-sm"
        }, " No billed/invoiced time entries ", -1)]))]))], 512), [[_vShow, nonWipExpanded.value]])]),
        _: 1
      })])])) : _createCommentVNode("", true)])), showTimeEntryModal.value ? (_openBlock(), _createBlock(TimeEntryModal, {
        key: 3,
        modelValue: showTimeEntryModal.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showTimeEntryModal.value = $event),
        state: props.state || {},
        stateParams: modalStateParams.value,
        params: {},
        rootScope: props.rootScope || {},
        alerts: props.alerts || {},
        snippetService: props.snippetService || {},
        entryEditService: props.entryEditService || {},
        tracking: props.tracking || {},
        clientMatterManager: props.clientMatterManager || {},
        isTimeEntryPage: false,
        hideDuplicateButton: true,
        onAddOrEditEntry: handleEntryUpdate
      }, null, 8, ["modelValue", "state", "stateParams", "rootScope", "alerts", "snippetService", "entryEditService", "tracking", "clientMatterManager"])) : _createCommentVNode("", true), _createVNode(LlConfirmationDialog, {
        ref_key: "billableConfirmRef",
        ref: billableConfirmRef,
        title: "Make Entries Billable?",
        message: _unref(billableConfirmMessage),
        "toggle-text": "Cancel",
        "confirm-text": "Make Billable",
        "show-warning-icon": false,
        "preserve-newlines": "",
        "data-cy": "make-billable-confirmation"
      }, null, 8, ["message"]), _createVNode(LlConfirmationDialog, {
        ref_key: "nonBillableConfirmRef",
        ref: nonBillableConfirmRef,
        title: "Make Entries Non-Billable?",
        message: _unref(nonBillableConfirmMessage),
        "toggle-text": "Cancel",
        "confirm-text": "Make Non-Billable",
        "show-warning-icon": false,
        "preserve-newlines": "",
        "data-cy": "make-nonbillable-confirmation"
      }, null, 8, ["message"]), _createVNode(LlAssignToFixedFeeModal, {
        modelValue: showAssignToFeeModal.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => showAssignToFeeModal.value = $event),
        "fixed-fee-list": availableCharges.value,
        loading: loadingCharges.value,
        "selected-count": selectedWipEntries.value.length,
        onConfirm: handleAssignToFee,
        onCancel: closeAssignToFeeModal
      }, null, 8, ["modelValue", "fixed-fee-list", "loading", "selected-count"]), _createVNode(ChangeMatterDialog, {
        modelValue: _unref(showChangeMatterDialog),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(showChangeMatterDialog) ? showChangeMatterDialog.value = $event : null),
        "selected-count": selectedWipEntries.value.length,
        "matter-form": _unref(changeMatterForm),
        "item-label": "time entry",
        "item-label-plural": "time entries",
        onConfirm: _unref(confirmChangeMatter),
        onCancel: _unref(closeChangeMatterDialog),
        onMatterChange: _unref(handleChangeMatterMatterChange)
      }, null, 8, ["modelValue", "selected-count", "matter-form", "onConfirm", "onCancel", "onMatterChange"])]);
    };
  }
};